import React, { createContext, useContext, useState } from 'react';
import { PuffLoader } from 'react-spinners';
import './LoadingStyles.css';

// Crear contexto
const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('Cargando...');

  const showLoading = (customMessage = 'Cargando...') => {
    setMessage(customMessage);
    setLoading(true);
    // Bloquear scroll y eventos
    document.body.classList.add('loading-active');
  };

  const hideLoading = () => {
    setLoading(false);
    // Restaurar scroll y eventos
    document.body.classList.remove('loading-active');
  };

  const withLoading = async (asyncFunction, customMessage = 'Cargando...') => {
    showLoading(customMessage);
    try {
      return await asyncFunction();
    } finally {
      hideLoading();
    }
  };

  return (
    <LoadingContext.Provider value={{ loading, message, showLoading, hideLoading, withLoading }}>
      {children}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-content">
            <PuffLoader color="#36d7b7" size={80} />
            <p>{message}</p>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
};

// Hook para usar el contexto
export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading debe ser usado dentro de un LoadingProvider');
  }
  return context;
};